<template>
    <div id="app" :class="codelevel + ' ' + layout" v-touch:swipe.left="swipeLeftHandler" v-touch:swipe.right="swipeRightHandler">
        <div class="wrapper">
            <div id="loading"></div>
            <sidebar></sidebar>
            <div id="content">
                <navigation></navigation>
                <message></message>
                <router-view :key="$route.fullPath"></router-view>
                <div class="footer">&nbsp;</div><!-- der untere Rand lässt sich nicht mit CSS einstellen? #919 -->
            </div>
            <cookie-consent>
                <template slot="message">
                    {{ $t('CookieMessage') }}
                    <a class="btn btn-link" :href="$t('CookieLinkhref')" target="_blank">{{ $t('CookieLinktext') }}</a>
                </template>
                <template slot="button">
                    <button class="btn btn-info">{{ $t('CookieGotIt') }}</button>
                </template>
            </cookie-consent>
        </div>
    </div>
</template>

<script>
import { bus } from "./main";
export default {
    name: "app",
    computed: {
        codelevel() {
            if (window.location.href.startsWith("https://legacy.dbmilch.ch")) return ''
            if (window.location.href.startsWith("https://legacy.bdlait.ch")) return ''
            return 'codelevel'
        },
        layout() {
            // für ein Kunden-Layout einer Organisation
            return this.$store.state.userStore.domain.layout
        }
    },
    methods: {
        swipeLeftHandler() {
            bus.$emit("SidebarClose")
        },
        swipeRightHandler() {
            bus.$emit("SidebarOpen")
        }
    }
};
</script>

<style lang="scss">
@import "../public/css/tsmVars.scss";
@import "../public/css/glyphicons.css";
@import "../public/css/robotoCondensed.scss";
@import "../node_modules/vue-cookieconsent-component/src/scss/_cookie-consent.scss";
@import "../node_modules/vue-cookieconsent-component/src/scss/_cookie-consent-bottom.scss";

body {
    padding: 0;
    margin: 0;
    font-family: RobotoCondensed, Arial, sans-serif;
    font-weight: 300; /* Roboto light */
    font-size: $tsmFontSizeNormal;
    letter-spacing: 0.05em;
    /*
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    */
    //text-align: center;
    color: $tsmtext;
}

/* predefined für bootstrap-vue, bootstrap-vue verwendet css von bootstrap4 also diese scss überschreiben und importieren */
/*
$navbar-light-color: $tsmdunkel;
$navbar-light-toggler-border-color: $tsmdunkel;
*/
$primary: $tsmdunkel;
$secondary: $tsmhover;
$table-accent-bg: $tsmhell; // vordefinierte Variable für Bootstrap table striped
$font-family-sans-serif: RobotoCondensed, Arial;  // !! Arial ist der fallback für Firefox in select>options !!!
$font-family-monospace: RobotoCondensed, Arial;

// führt zu einem Fehler bei den <SELECT> Pfeilen ..
// @import 'bootstrap/scss/bootstrap.scss'; wont work without autoprefixer .. ???

@import "../node_modules/bootstrap/scss/bootstrap.scss";
//@import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
@import "../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

#app {
    .table-sm thead th.sorting {
        padding-right: 1.5em !important; // sonst werden die Sorting Pfeile überdeckt
    }
    .navbar,
    h1,
    h2,
    h3 {
        font-size: $tsmFontSizeTitle;
    }

    #topbar {
        background-color: $tsmhover;
        color: white !important;
        font-size: 1.6em;
        .navbar {
            padding-bottom: 10px;
        }
    }

    //https://bootstrapious.com/p/bootstrap-sidebar
    .wrapper {
        display: flex;
        flex-direction: row;
        width: 100%;
        min-height: 100vh;
        //align-items: stretch;
    }

    #sidebar {
        min-width: 250px;
        max-width: 250px;
        min-height: 100vw;
        transition-property: margin-left;
        //transition-duration: 0.2s;
        transition-timing-function: ease, ease, linear;
        background-color: $tsmnormal;
        //display: flex;
    }

    #sidebar.disabled {
        margin-left: -250px;
    }

    #content {
        width: 100vw;
    }

    #loading {
        position: fixed;
        display: none;
        top: 160px;
        left: 30%;
        width: 40px;
        height: 40px;
        z-index: 1000;
        color: white;
        background-image: url("../public/images/progress.gif");
        background-repeat: no-repeat;
    }

    .btn-wrap {
        white-space: normal !important;
        word-wrap: break-word !important;
    }
}

iframe {
    border: 0;
}

//bootstrap modal Scroll fix
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto !important;
    padding-right: 17px;
}

#app.codelevel #burgerbar.navbar {
    background-image: url(../public/images/dbmilch_test_de.png);
    background-repeat: no-repeat;
    background-position: top left;
    @media (min-width: map-get($grid-breakpoints, md)) {
        //grid-breakpoints sind bootstrap predefines /node-modules/bootstrap4/scss/_variables.scss
        background-position: top right;
    }
}

#app.mooh #burgerbar.navbar {
    background-image: url(../public/images/mooh.png);
    background-repeat: no-repeat;
    $stretch: 0.4;
    background-size: $stretch * 178px $stretch * 225px;
    background-position: left 180px top 0;
    @media (max-width: map-get($grid-breakpoints, md)) {
        $stretch: 0.57;
        background-size: $stretch * 178px $stretch * 225px;
        background-position: top right 180px;
    }
}

#app.codelevel.mooh #burgerbar.navbar {
    background-image: url(../public/images/mooh.png), url(../public/images/dbmilch_test_de.png) ;
    background-repeat: no-repeat, no-repeat;
    $stretch: 0.4;
    background-size: $stretch * 178px $stretch * 225px, 200px 136px;
    background-position: left 180px top 0, top right;
    @media (max-width: map-get($grid-breakpoints, md)) {
        $stretch: 0.57;
        background-position: top right 180px, top left;
        background-size: $stretch * 178px $stretch * 225px, 200px 136px;
    }
}

#app.prolait #burgerbar.navbar {
    background-image: url(../public/images/prolait.png);
    background-repeat: no-repeat;
    $stretch: 0.4;
    background-size: $stretch * 417px $stretch * 160px;
    background-position: right 180px bottom 10px;
    @media (min-width: map-get($grid-breakpoints, md)) {
        background-position: left 175px top 10px;
    }
}

#app.codelevel.prolait #burgerbar.navbar {
    background-image: url(../public/images/prolait.png), url(../public/images/dbmilch_test_de.png);
    background-repeat: no-repeat, no-repeat;
    $stretch: 0.4;
    background-size: $stretch * 417px $stretch * 160px, 200px 136px;
    background-position: right 180px bottom 10px, top left;
    @media (min-width: map-get($grid-breakpoints, md)) {
        background-position: left 175px top 10px, top right;
    }
}

#app.vmm #burgerbar.navbar {
    background-image: url(../public/images/vmm.jpg);
    background-repeat: no-repeat;
    $stretch: 0.3;
    background-size: $stretch * 500px $stretch * 260px;
    background-position:right 180px bottom 10px;
    @media (min-width: map-get($grid-breakpoints, md)) {
        background-position: left 175px top 10px;
    }
}

#app.codelevel.vmm #burgerbar.navbar {
    background-image: url(../public/images/vmm.jpg), url(../public/images/dbmilch_test_de.png);
    background-repeat: no-repeat, no-repeat;
    $stretch: 0.3;
    background-size: $stretch * 500px $stretch * 260px, 200px 136px;
    background-position: right 180px bottom 10px, top left;
    @media (min-width: map-get($grid-breakpoints, md)) {
        background-position: left 175px top 10px, top right;
    }
}
</style>